<div class="page-maintenance">
  <header class="top-header text-center">
    <a [routerLink]="['/']" class="logo">{{ AppConfig.pageTitle }}</a>
  </header>

  <div class="content">
    <div class="title-content text-center">
      <h1>
        <language key="MaintenanceTitle" defaultValue="Site is Under Maintenance"></language>
      </h1>
    </div>

    <div class="row">
      <div class="col-xl-4">
        <div class="icon-box">
          <mat-icon>info_outline</mat-icon>
          <h3>
            <language key="MaintenanceWhyDown" defaultValue="Why is the Site Down?"></language>
          </h3>
          <p>{{ (uiconfiguration | async)?.info }}</p>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="icon-box">
          <mat-icon>access_time</mat-icon>
          <h3>
            <language key="MaintenanceAbout" defaultValue="What is the Downtime?"></language>
          </h3>
          <p>{{ (uiconfiguration | async)?.downtimeinfo }}</p>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="icon-box">
          <mat-icon>mail_outline</mat-icon>
          <h3>
            <language key="MaintenanceSupport" defaultValue="Do you need Support?"></language>
          </h3>
          <p>
            <language
              key="MaintenanceHelp"
              defaultValue="You may send us an Email at {0} if you need urgent
                        support."
              [args]="[(uiconfiguration | async)?.email]"
            >
            </language>
            <a href="mailto:{{ (uiconfiguration | async)?.email }}">{{
              (uiconfiguration | async)?.email
            }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
